import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './Sidebar.css';

/**
 * Left-hand navigation.
 *
 * Links are grouped by module rather than listed flat, so a second generator
 * added later becomes a new group alongside "Certificate of Good Standing"
 * instead of more entries in an undifferentiated list. Anything that applies
 * across the whole system sits under "System".
 */
const NAV_GROUPS = [
  {
    label: 'Certificate of Good Standing',
    items: [
      { to: '/dashboard', label: 'Dashboard' },
      { to: '/actions', label: 'Action Required' },
      { to: '/applications', label: 'All Applications' },
      { to: '/commodities', label: 'Commodities' },
      { to: '/inspectors', label: 'Inspectors' },
      { to: '/templates', label: 'Templates', superAdminOnly: true },
    ],
  },
  {
    label: 'System',
    items: [
      { to: '/users', label: 'Users', superAdminOnly: true },
      { to: '/audit', label: 'Activity Log' },
      { to: '/settings', label: 'Settings' },
    ],
  },
];

function Sidebar() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  let user = {};
  try {
    user = JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    user = {};
  }

  const isSuperAdmin = user.role === 'Super Admin';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const close = () => setOpen(false);

  const initials = `${(user.firstName || '?')[0] || ''}${(user.lastName || '')[0] || ''}`.toUpperCase();

  return (
    <>
      {/* Mobile top bar — the sidebar becomes a drawer below 900px. */}
      <div className="sb-mobilebar">
        <button
          className="sb-hamburger"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
          aria-expanded={open}
        >
          <span className={`sb-line ${open ? 'open' : ''}`} />
          <span className={`sb-line ${open ? 'open' : ''}`} />
          <span className={`sb-line ${open ? 'open' : ''}`} />
        </button>
        <span className="sb-mobilebar-title">Certificate Generator</span>
      </div>

      <aside className={`sb-sidebar${open ? ' sb-open' : ''}`}>
        <div className="sb-brand">
          <img src="/fsa-logo.png" alt="Food Safety Agency" className="sb-logo" />
          <span className="sb-brand-text">
            <span className="sb-brand-name">Certificate Generator</span>
            <span className="sb-brand-org">Food Safety Agency</span>
          </span>
        </div>

        <nav className="sb-nav">
          {NAV_GROUPS.map((group) => {
            const items = group.items.filter((i) => !i.superAdminOnly || isSuperAdmin);
            if (items.length === 0) return null;

            return (
              <div className="sb-group" key={group.label}>
                <span className="sb-group-label">{group.label}</span>
                {items.map((item) => (
                  <NavLink key={item.to} to={item.to} onClick={close} className="sb-link">
                    {item.label}
                  </NavLink>
                ))}
              </div>
            );
          })}
        </nav>

        <div className="sb-user">
          <div className="sb-user-row">
            <span className="sb-avatar">{initials || '?'}</span>
            <span className="sb-user-text">
              <span className="sb-user-name">{user.firstName} {user.lastName}</span>
              <span className="sb-user-role">{user.role || 'Manager'}</span>
            </span>
          </div>
          <button onClick={handleLogout} className="sb-logout">Sign Out</button>
        </div>
      </aside>

      {open && <div className="sb-overlay" onClick={close} />}
    </>
  );
}

export default Sidebar;
